import React from 'react'
import PrivacyCustomHeading from '../other/common/PrivacyCustomHeading';
import { TERMS_POLICY_LIST } from '../../utils/other-component';

const TermsText = () => {
  return (
    <>
      <div className="py-[140px] max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="w-full max-w-[768px] mx-auto px-4">
          <h3 className="text-[#010101] text-lg font-semibold leading-[120%] mb-4">
            Last Updated April 23, 2025
          </h3>
          <PrivacyCustomHeading text="Terms of Conditions" />
          <p className="text-[#515151] text-base font-normal leading-[150%] ff-jakarta mt-4">
            Welcome to{" "}
            <span className="text-[#010101] font-bold"> Makeway India.</span> By
            accessing our website, using our services, or engaging with our
            wellness products, you agree to the following terms and conditions.
            Please read them carefully.
          </p>
          <div className={``}>
            {TERMS_POLICY_LIST.map((item, index) => (
              <div
                className={`max-md:mt-6 mt-10`}
                key={index}
              >
                <PrivacyCustomHeading text={item.heading} />
                <p className="text-[#515151] text-base font-normal leading-[150%] ff-jakarta mt-4">
                  {item.description}
                </p>
              </div>
            ))}
            <p className="text-[#010101] font-bold text-base leading-[150%] pt-3 mb-10">
              Email:
              <a href='mailto: support@makewayindia.com' className="text-base font-normal leading-[150%] text-[#0579E1]">
                support@makewayindia.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className="h-[140px]"></div>
    </>
  );
}

export default TermsText